import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MentionUtilsService {
  constructor() {}

  isTextElement(el: HTMLElement): boolean {
    return (
      el != null &&
      (el.nodeName == 'INPUT' ||
        el.nodeName == 'TEXTAREA' ||
        el.nodeName == '#text')
    );
  }

  pasteHtmlAtCaret(
    el: HTMLInputElement,
    html: string,
    start: number,
    end: number,
    iframe
  ) {
    //var sel, range;
    // IE9 and non-IE
    /*sel = window.getSelection();
    if (sel.getRangeAt && sel.rangeCount) {
      console.log(sel);
      range = sel.getRangeAt(0);
      range.deleteContents();*/
    console.log(el, start, end);
    let range = this.getDocument(iframe).createRange();
    range.setStart(el, start);
    range.setEnd(el, end);
    console.log(range.toString());
    range.deleteContents();
    let sel = this.getWindowSelection(iframe);
    sel.removeAllRanges();
    sel.addRange(range);

    // Range.createContextualFragment() would be useful here but is
    // only relatively recently standardized and is not supported in
    // some browsers (IE9, for one)
    let el2 = document.createElement('div');
    el2.innerHTML = html + ' ';
    let frag = document.createDocumentFragment(),
      node,
      lastNode;
    while ((node = el2.firstChild)) {
      lastNode = frag.appendChild(node);
    }
    range.insertNode(frag);

    // Preserve the selection
    if (lastNode) {
      range = range.cloneRange();
      range.setStartAfter(lastNode);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
    }
    //}
  }

  setCaretPosition(
    el: HTMLInputElement,
    pos: number,
    iframe: HTMLIFrameElement = null
  ) {
    //console.log("setCaretPosition", pos, el, iframe==null);
    if (this.isInputOrTextAreaElement(el) && el.selectionStart) {
      el.focus();
      el.setSelectionRange(pos, pos);
    } else {
      let range = this.getDocument(iframe).createRange();
      range.setStart(el, pos);
      range.collapse(true);
      let sel = this.getWindowSelection(iframe);
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }

  setValue(el: HTMLInputElement, value: any) {
    //console.log("setValue", el.nodeName, "["+value+"]");
    if (this.isInputOrTextAreaElement(el)) {
      el.value = value;
    } else {
      el.innerHTML = value;
    }
  }

  insertValue(
    el: HTMLInputElement,
    start: number,
    end: number,
    text: string,
    iframe: HTMLIFrameElement,
    noRecursion: boolean = false
  ) {
    console.log('insertValue', el.nodeName, start, end, '[' + text + ']', el);
    /* if (el.contentEditable) {
  
      pasteHtmlAtCaret(el, text, start, end, iframe);
    }
    else*/ if (this.isTextElement(el)) {
      if (el.nodeName == '#text') {
        this.pasteHtmlAtCaret(el, text, start, end, iframe);
      } else {
        let val = this.getValue(el);
        this.setValue(
          el,
          val.substring(0, start) + text + val.substring(end, val.length)
        );
        this.setCaretPosition(el, start + text.length, iframe);
      }
    } else if (!noRecursion) {
      let selObj: Selection = this.getWindowSelection(iframe);
      if (selObj && selObj.rangeCount > 0) {
        var selRange = selObj.getRangeAt(0);
        var position = selRange.startOffset;
        var anchorNode = selObj.anchorNode;
        // if (text.endsWith(' ')) {
        //   text = text.substring(0, text.length-1) + '\xA0';
        // }
        this.insertValue(
          <HTMLInputElement>anchorNode,
          position - (end - start),
          position,
          text,
          iframe,
          true
        );
      }
    }
  }

  getCaretPosition(el: HTMLInputElement, iframe: HTMLIFrameElement = null) {
    //console.log("getCaretPosition", el);
    if (this.isInputOrTextAreaElement(el)) {
      var val = el.value;
      return val.slice(0, el.selectionStart).length;
    } else {
      var selObj = this.getWindowSelection(iframe); //window.getSelection();
      if (selObj.rangeCount > 0) {
        var selRange = selObj.getRangeAt(0);
        var preCaretRange = selRange.cloneRange();
        preCaretRange.selectNodeContents(el);
        preCaretRange.setEnd(selRange.endContainer, selRange.endOffset);
        var position = preCaretRange.toString().length;
        return position;
      }
    }
  }

  getValue(el: HTMLInputElement) {
    return this.isInputOrTextAreaElement(el) ? el.value : el.textContent;
  }
  isInputOrTextAreaElement(el: HTMLElement): boolean {
    return el != null && (el.nodeName == 'INPUT' || el.nodeName == 'TEXTAREA');
  }

  getContentEditableCaretCoords(ctx: {
    iframe: HTMLIFrameElement;
    parent?: Element;
  }) {
    let markerTextChar = '\ufeff';
    let markerId =
      'sel_' + new Date().getTime() + '_' + Math.random().toString().substr(2);
    let doc = this.getDocument(ctx ? ctx.iframe : null);
    let sel = this.getWindowSelection(ctx ? ctx.iframe : null);
    let prevRange = sel.getRangeAt(0);

    // create new range and set postion using prevRange
    let range = doc.createRange();
    range.setStart(sel.anchorNode, prevRange.startOffset);
    range.setEnd(sel.anchorNode, prevRange.startOffset);
    range.collapse(false);

    // Create the marker element containing a single invisible character
    // using DOM methods and insert it at the position in the range
    let markerEl = doc.createElement('span');
    markerEl.id = markerId;
    markerEl.appendChild(doc.createTextNode(markerTextChar));
    range.insertNode(markerEl);
    sel.removeAllRanges();
    sel.addRange(prevRange);

    let coordinates = {
      left: 0,
      top: markerEl.offsetHeight,
    };
    if (ctx.iframe) this.localToRelativeCoordinates(ctx, markerEl, coordinates);

    markerEl.parentNode.removeChild(markerEl);
    return coordinates;
  }

  localToRelativeCoordinates(
    ctx: { iframe: HTMLIFrameElement; parent?: Element },
    element: Element,
    coordinates: { top: number; left: number }
  ) {
    console.log(coordinates, 'woof');
    let obj = <HTMLElement>element;
    let iframe = ctx ? ctx.iframe : null;
    while (obj) {
      if (ctx.parent != null && ctx.parent == obj) {
        break;
      }
      console.log('OBBBB', obj);
      console.log(coordinates, 'WOO');
      coordinates.left += obj.offsetLeft + obj.clientLeft;
      coordinates.top += obj.offsetTop + obj.clientTop;
      obj = <HTMLElement>obj.offsetParent;
      if (!obj && iframe) {
        obj = iframe;
        iframe = null;
      }
    }
    console.log(coordinates, 'grr');
    obj = <HTMLElement>element;
    iframe = ctx ? ctx.iframe : null;
    while (obj !== this.getDocument(null).body && obj != null) {
      if (ctx.parent != null && ctx.parent == obj) {
        break;
      }
      if (obj.scrollTop && obj.scrollTop > 0) {
        coordinates.top -= obj.scrollTop;
      }
      if (obj.scrollLeft && obj.scrollLeft > 0) {
        coordinates.left -= obj.scrollLeft;
      }
      obj = <HTMLElement>obj.parentNode;
      if (!obj && iframe) {
        obj = iframe;
        iframe = null;
      }
    }
    console.log(coordinates, 'asdfasfas/*  */');
  }

  getDocument(iframe: HTMLIFrameElement) {
    if (!iframe) {
      return document;
    } else {
      return iframe.contentWindow.document;
    }
  }

  getWindowSelection(iframe: HTMLIFrameElement): Selection {
    if (!iframe) {
      return window.getSelection();
    } else {
      return iframe.contentWindow.getSelection();
    }
  }
}
